import $ from 'jquery';
import 'slick-carousel';

$(document).ready(function() {

	$('#banner--logos--slider').slick({
		arrows: true,
		autoplay: true,
		autoplaySpeed: 3000,
		dots: false,
		infinite: true,
		speed: 300,
		slidesToShow: 3,
		slidesToScroll: 3,
		nextArrow: '<i class="fa fa-angle-right slick-right"></i>',
		prevArrow: '<i class="fa fa-angle-left slick-left"></i>',
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2
			}
		},
		{
			breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});	
	
	$('#slider--equipe').slick({
		arrows: false,
		autoplay: true,
		autoplaySpeed: 3000,
		dots: true,
		infinite: true,
		speed: 300,
		slidesToShow: 1,
		slidesToScroll: 1
	});

	$('#slider--agence').slick({
		arrows: false,
		autoplay: true,
		autoplaySpeed: 3000,
		dots: true,
		infinite: true,
		speed: 300,
		slidesToShow: 1,
		slidesToScroll: 1
	});

});